module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead11-75317bf520c6319f0aed31cb93c713bc.jpg";